import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';

import Dropdown from 'widgets/Dropdown/Dropdown';

export default class PrimaryBarDropdown extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    href: PropTypes.string,
    label: PropTypes.node,
    rawLabel: PropTypes.string,
    className: PropTypes.string,
    linkClassName: PropTypes.string,
    linkActiveClassName: PropTypes.string,
    linkTitle: PropTypes.string,
    locked: PropTypes.bool,
    analyticsEventSender: PropTypes.func,
  };

  static defaultProps = {
    href: '#',
    linkClassName: 'primaryBar__link',
    locked: false,
    analyticsEventSender: () => undefined,
  };

  state = {
    // We don't need to render dropdown content until the user activates it for the first time
    isRendered: false,
    isOpen: false,
  };

  componentWillUnmount() {
    clearTimeout(this.timeoutToCollapseOnBlur);
    clearTimeout(this.timeoutToExpand);
    clearTimeout(this.timeoutToCollapse);
  }

  onClick = (event) => {
    if (!this.props.href || this.props.href === '#' || !this.state.isOpen) {
      event.preventDefault();
    } else {
      this.props.analyticsEventSender(this.props.rawLabel);
    }
    this.toggle();
  };

  onMouseDown = () => { this.ignoreFocus = true; }

  onMouseUp = () => { this.ignoreFocus = false; }

  onFocus = () => {
    // If that wasn't there, onFocus would fire when clicking with the mouse, causing dropdown to flash and disappear
    if (this.ignoreFocus) {
      return;
    }

    this.expand();
  }

  timeoutToCollapseOnBlur = null;

  timeoutToCollapse = null;

  timeoutToExpand = null;

  delayInMs = 200;

  expand = () => {
    if (this.props.locked) return false;

    return this.setState({
      isRendered: true,
      isOpen: true,
    });
  }

  expandAfterDelay = () => {
    clearTimeout(this.timeoutToCollapse);
    this.timeoutToExpand = setTimeout(this.expand, this.delayInMs);
  };

  collapse = () => {
    this.setState({ isOpen: false });
  };

  collapseAfterDelay = () => {
    clearTimeout(this.timeoutToExpand);
    this.timeoutToCollapse = setTimeout(this.collapse, this.delayInMs);
  };

  // If the user is focused of current dropdown, we need to collapse it
  collapseOnBlur = () => {
    this.timeoutToCollapseOnBlur = setTimeout(() => {
      const stillHasFocus = this.container && this.container.querySelector(':focus, :hover');
      if (!stillHasFocus) {
        this.collapse();
      }
    }, 0);
  };

  toggle = () => (
    this.state.isOpen
      ? this.collapse()
      : this.expand()
  );

  render() {
    const { children, href, label, className, linkClassName, linkActiveClassName, linkTitle } = this.props;
    const { isRendered, isOpen } = this.state;
    const linkAttrs = {
      activeClassName: linkActiveClassName,
      className: linkClassName,
      onClick: this.onClick,
      title: linkTitle,
      to: href,
    };

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={classNames('primaryBarDropdown', { open: isOpen }, className)}
        onMouseEnter={this.expandAfterDelay}
        onMouseLeave={this.collapseAfterDelay}
        onMouseDown={this.onMouseDown}
        onMouseUp={this.onMouseUp}
        onFocus={this.onFocus}
        onBlur={this.collapseOnBlur}
        ref={ref => { this.container = ref; }}
      >
        <Link {...linkAttrs}>
          {label}
        </Link>
        {
          isRendered && (
            <Dropdown
              isOpen={isOpen}
              collapse={this.collapse}
            >
              {children}
            </Dropdown>
          )}
      </div>
    );
  }
}
